/**
 * Module dependencies.
 */

import { AxiosInstance } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * `ResetPayload` type.
 */

export type ResetPayload = { password: string; token: string };

/**
 * Reset password.
 */

function resetPassword(client: AxiosInstance, payload: ResetPayload): Promise<void> {
  return client.post(resolveAppUrl('resetPassword'), payload).then(({ data }) => data);
}

/**
 * `Options` type.
 */

type Options = UseMutationOptions<void, unknown, ResetPayload, unknown>;

/**
 * Export `useResetPassword`.
 */

export function useResetPassword(options?: Options) {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: ResetPayload) => {
      return await resetPassword(client, payload);
    },
    ...options
  });
}
